export enum VideoType {
  Stream = "stream",
  Video = "video",
}
